import { useEffect, useState, useCallback } from 'react'
import { useWebSocket } from '@/context/websocket-context/WebSocketContext'
import { WebSocketMessage } from '@/context/websocket-context/WebSocketContext'
import { CreditStatus } from '@/lib/services'

interface CreditAlertPayload {
  current_balance: number
  threshold: number
  message: string
}

interface CreditWebSocketMessage extends WebSocketMessage {
  type: 'credit_alert' | 'error'
  payload: CreditAlertPayload
}

export const useCreditWebSocket = () => {
  const { isConnected, addMessageHandler, removeMessageHandler } = useWebSocket()
  const [creditStatus, setCreditStatus] = useState<CreditStatus | null>(null)
  const [error, setError] = useState<string | null>(null)

  const handleMessage = useCallback((message: WebSocketMessage) => {
    if (message.type !== 'credit_alert' && message.type !== 'error') {
      return
    }

    const creditMessage = message as CreditWebSocketMessage

    switch (creditMessage.type) {
      case 'credit_alert':
        const creditPayload = creditMessage.payload as CreditAlertPayload
        setCreditStatus({
          isLowCredit: true,
          currentBalance: creditPayload.current_balance,
          threshold: creditPayload.threshold,
          message: creditPayload.message
        })
        break
      case 'error':
        setError(creditMessage.error || 'An error occurred')
        break
    }
  }, [])

  useEffect(() => {
    if (isConnected) {
      addMessageHandler(handleMessage)
      return () => {
        removeMessageHandler(handleMessage)
      }
    }
  }, [isConnected, addMessageHandler, removeMessageHandler, handleMessage])

  return {
    creditStatus,
    error,
    isConnected
  }
} 
